import { required } from 'vuelidate/lib/validators';

export const getFields = ($t) => {
    return {
        nameField: {
            atrName: "name",
            dataType: "text",
            descr: $t('components.auth.login.email_field_desc'),
            isMandatory: true,
            maxValue: "85",
            minValue: "5",
            title: "Meno"
        },
        surnameField: {
            atrName: "surname",
            dataType: "text",
            descr: $t('components.auth.login.email_field_desc'),
            isMandatory: true,
            maxValue: "85",
            minValue: "5",
            title: "Priezvisko"
        },
        emailField: {
            atrName: "email",
            dataType: "text",
            descr: $t('components.auth.login.email_field_desc'),
            isMandatory: true,
            maxValue: "85",
            minValue: "5",
            title: "E-mail"
        },
        telephoneField: {
            atrName: "telephone",
            dataType: "text",
            descr: $t('components.auth.login.email_field_desc'),
            isMandatory: true,
            maxValue: "85",
            minValue: "5",
            title: "Telefónne číslo"
        },
        commentField: {
            atrName: "comment",
            dataType: "text",
            descr: $t("components.order.dispute.disputeForm.text_title"),
            isMandatory: true,
            title: 'Správa'
        }
    };
};

export const validations = {
    name: {
        required
    },
    surname: {
        required
    },
    email: {
        required
    },
    telephone: {
        required
    },
    comment: {
        required
    }
};